export default __webpack_public_path__ + "assets/8ee05dbb0411eeeec4d22199c1946b97.png";